import {
  FETCH_EVALUATIONS_REQUEST,
  SAVE_EVALUATION_REQUEST,
  CHANGE_EVALUATION_STATUS_REQUEST,
} from "./actionTypes";

export const fetchEvaluations = (unitId) => ({
  type: FETCH_EVALUATIONS_REQUEST,
  payload: { unitId }
});

export const saveEvaluation = (data) => ({
  type: SAVE_EVALUATION_REQUEST,
  payload: data,
});

export const changeEvaluationStatus = (payload) => ({
  type: CHANGE_EVALUATION_STATUS_REQUEST,
  payload,
});
